<template>
  <div class="comment-suggestion" @click="handleCommentSuggestionClick">
    <a-row type="flex" class="h-100" align="middle">
      <a-col :span="24">
        <p class="no-margin text-suggestion">{{ minmizedText(text) }}</p>
      </a-col>
    </a-row>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CommentSuggestion',
  props: {
    text: undefined
  },
  methods: {
    ...mapActions({
      'setOngoingAlteredRow': 'detail/setOngoingAlteredRow'
    }),
    handleCommentSuggestionClick () {
      this.$emit('clicked', this.text)
    },
    minmizedText (text) {
      if (text.length > 35) {
        return text.toString().substring(0, 35) + '...'
      }
      return text
    }
  },
  computed: {
    ...mapState({
      ongoingAlteredRow: state => state.detail.ongoingAlteredRow
    })
  }
}
</script>

<style scoped lang="scss">
.comment-suggestion{
  transition: all 0.1s linear;
  cursor: pointer;
  margin-top: 15px;
  width: 150px;
  height: 60px;
  border-radius: 5px;
  background-image: radial-gradient(circle, #34495e, #32465a, #304357, #2e4153, #2c3e50);
}
.comment-suggestion:hover{
  width: 152px;
  height: 62px;
}
.comment-suggestion:active:hover{
  width: 148px;
  height: 58px;
}
.text-suggestion{
  text-align: center;
  color: #fff;
  white-space: normal;
}
</style>
